<template>
  <v-layout align-center justify-center>
    <div class="page__onboarding">
      <img src="@/assets/img/logos/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="page__onboarding__logo">
      <img src="./img/airplane.svg" class="page__onboarding__left-img">
      <img src="./img/man.svg" class="page__onboarding__right-img">

      <form class="form--custom" novalidate @submit.prevent="handleSubmit">
        <h2 class="page__onboarding__title" v-html="$t(`${namespace}.onboarding.title`)" />
        <p class="page__onboarding__text" v-html="$t(`${namespace}.onboarding.text`)" />

        <v-layout wrap>
          <v-flex sm12 md6>
            <FormTextField
              v-model="form.password"
              type="password"
              :label="$t(`${namespace}.form.passwordLabel`)"
              :placeholder="$t(`${namespace}.form.passwordPlaceholder`)"
              :disabled="submitted"
              :name="$t(`${namespace}.form.passwordName`)"
              :v-validate="{
                required: true,
                isValidPassword: true,
                min: 8
              }"
            />

            <FormTextField
              v-model="form.passwordConfirm"
              type="password"
              :label="$t(`${namespace}.form.confirmPasswordLabel`)"
              :placeholder="$t(`${namespace}.form.confirmPasswordPlaceholder`)"
              :disabled="submitted"
              :name="$t(`${namespace}.form.confirmPasswordName`)"
              :v-validate="{
                required: true,
                is: form.password,
                isValidPassword: true,
                min: 8
              }"
            />

            <div class="mb-4">
              <Button
                type="submit"
                color="secondary"
                gradient
                :disabled="submitted"
                :loading="submitted"
                block
                large
              >
                {{ $t(`${namespace}.onboarding.buttonLabel`) }}
              </Button>
            </div>
          </v-flex>

          <v-flex sm12 md6>
            <PasswordTips
              class="mb-0 page__onboarding__password-tips"
              :password="form.password"
            />
          </v-flex>
        </v-layout>
      </form>
    </div>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'
import session from '@/services/modules/session'
import formValidator from 'mixins/formValidator'
import PasswordTips from 'components/PasswordTips'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'OnboardingForm',
  mixins: [formValidator],
  components: {
    PasswordTips
  },
  computed: {
    routeName () {
      return this.$route.name
    },

    token () {
      return this.$route.params.token
    }
  },
  data () {
    return {
      namespace: 'Views.ResetPasswordPage',
      form: {
        password: null,
        passwordConfirm: null
      },
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    resetFields () {
      this.form = {
        ...this.form,
        password: null,
        passwordConfirm: null
      }
    },

    setSubmittedValue (boolean = true) {
      this.submitted = boolean
    },

    async handleSubmit () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      this.setSubmittedValue(true)

      try {
        const { token, form } = this

        await session.resetPassword({
          token,
          newPassword: form.password
        })

        const message = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.form.firstAccessSuccess`)
          : this.$t(`${this.namespace}.form.resetPasswordSuccess`)

        this.showAlert({ type: 'success', message })
        this.redirectToLogin()
      } catch (error) {
        const reason = error?.response?.data?.reasons && error.response.data.reasons[0]
        const message = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.form.firstAccessError`)
          : this.$t(`${this.namespace}.form.resetPasswordError`)

        this.showAlert({
          type: 'error',
          message: reason || message
        })

        catchError(error)
      }

      this.setSubmittedValue(false)
    }
  },
  created () {
    session.logout()
  },
  beforeMount () {
    !this.token && this.redirectToLogin()
  }
}
</script>

<style lang="scss" scoped>
.page__onboarding {
  background-color: $white;
  border-left: 1px solid $gray-3;
  border-right: 1px solid $gray-3;
  max-width: 683px;
  padding: 30px;
  position: relative;

  @media (min-width: 961px) {
    height: 100vh;
    padding: 30px 120px 30px 92px;
  }

  .form--custom {
    width: 100%;
  }

  .v-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;

    @media (min-width: 961px) {
      width: auto;
    }
  }
}

.page__onboarding__logo {
  display: block;
  margin: 0 auto 30px;
}

.page__onboarding__left-img,
.page__onboarding__right-img {
  display: none;
  position: absolute;
  z-index: 1;

  @media (min-width: 961px) {
    display: inline-block;
  }
}

.page__onboarding__left-img {
  left: -19px;
  top: -28px;
}

.page__onboarding__right-img {
  right: -1px;
  top: ($toolbar-height * 2);
}

.page__onboarding__title {
  color: $gray-8;
  font-family: $title-font;
  font-size: 21px;
  font-weight: 800;
  margin-bottom: 16px;

  > span {
    color: $accent;
    display: block;
    font-size: 21px;
  }
}

.page__onboarding__text {
  color: $gray-6;
  margin-bottom: 24px;
}
</style>

<style lang="scss">
.page__onboarding__password-tips {
  background-color: $gray-1;
  border-radius: 4px;
  padding: 16px 6px 15px 19px;

  @media (min-width: 961px) {
    margin-left: 42px;
  }

  .password-tips__title,
  .password-tips__item span {
    font-size: $base-font-size - 1px;
  }

  .password-tips__title {
    color: var(--gray-7);
    font-family: $title-font;
    font-weight: 600;
  }
}
</style>
